import { Box, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"

import {
  ContentContainer,
  SourceDescription,
  CenterContainer,
  RecipientContainer,
  ContinueButton,
  ButtonTransfer,
} from "./styled"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"

const ErrorPage = () => {
  const navigate = useNavigate()
  const handleClickBack = () => {
    navigate("/")
  }

  return (
    <ContentContainer>
      <CenterContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="globalErrorIcon" size={80} />
        </IconBox>
        <SourceDescription variant="h3">Что-то пошло не так</SourceDescription>
        <RecipientContainer>
          <Typography variant="h4">Попробуйте еще раз</Typography>
        </RecipientContainer>
      </CenterContainer>
      <Box sx={ButtonTransfer}>
        <ContinueButton variant="contained" fullWidth onClick={handleClickBack}>
          Попробовать еще раз
        </ContinueButton>
      </Box>
    </ContentContainer>
  )
}

export default ErrorPage
